import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Button,
  Typography
} from "../../../../node_modules/@material-ui/core/index";
import Loader from "../Loader";
import { API } from "aws-amplify";
import { navigate } from "@reach/router";
import Snackbar from "../../../components/Snackbar/Snackbar";
import { messagefnSwitcher, messageSwitcher } from "../../../utils/formHelper";

const styles = theme => ({
  uploadWrapper: {
    marginTop: 20,
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  uploadTitle: {
    marginBottom: 5
  }
});

const ImportFormNew = ({ classes, survey, jwtToken }) => {
  const [selectedFile, setSelectedFile] = useState("");
  const [jsonContent, setJsonContent] = useState({});
  const [loader, setLoader] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const renderMessage = (message, messageFunc, variant) => {
    if (!message) {
      return "";
    }
    return (
      <Snackbar
        message={message}
        onClose={() => messageFunc(null)}
        open={Boolean(message)}
        variant={variant}
      />
    );
  };

  const onSelectFile = e => {
    setSelectedFile(e.target.files[0]);

    const fileReader = new FileReader();
    fileReader.readAsText(e.target.files[0], "UTF-8");
    fileReader.onload = e => {
      setJsonContent(JSON.parse(e.target.result));
    };
  };

  const onUploadSpec = async () => {
    setLoader(true);

    try {
      await API.put("surveys", `/surveys/${survey._id}/importer`, {
        body: {
          ...jsonContent
        },
        headers: { Authorization: `Bearer ${jwtToken}` }
      });

      setSuccessMessage("imported survey successfully");
      navigate(`/admin/surveys/${survey.name}`);
    } catch (e) {
      setErrorMessage(e.message);
      console.log(e);
    }

    setLoader(false);
  };

  return (
    <>
      <Loader loader={loader} message="uploading" />

      <Button variant="contained" component="label">
        Select Survey Spec (JSON)
        <input
          type="file"
          hidden
          accept="application/JSON"
          onChange={onSelectFile}
        />
      </Button>

      {selectedFile && (
        <div className={classes.uploadWrapper}>
          <Typography className={classes.uploadTitle}>
            Selected File: {selectedFile.name}
          </Typography>

          <Button variant="contained" component="label" onClick={onUploadSpec}>
            Upload
          </Button>
        </div>
      )}

      {renderMessage(
        errorMessage || successMessage,
        messagefnSwitcher(
          errorMessage,
          successMessage,
          setErrorMessage,
          setSuccessMessage
        ),
        messageSwitcher(errorMessage)
      )}
    </>
  );
};

export default withStyles(styles)(ImportFormNew);
